import { Facility } from "@app/shared";
import { useCallback, useState } from "react";
import { ClientEndpointTable, EventTriggerTable, LuxcomBiuSettings } from "@app/shared/src/components/Integrations";

type FacilityIntegrationsProps = {
    facility: Facility;
    onChange: () => void;
};

export const FacilityIntegrations: React.FC<FacilityIntegrationsProps> = ({ facility, onChange }) => {
    const [triggerRefreshKey, setTriggerRefreshKey] = useState(0);
    const [endpointRefreshKey, setEndpointRefreshKey] = useState(0);

    const handleTriggerDataChange = useCallback(() => {
        setTriggerRefreshKey((prev) => prev + 1);
    }, []);

    const handleEndpointDataChange = useCallback(() => {
        setEndpointRefreshKey((prev) => prev + 1);
    }, []);

    return (
        <>
            <ClientEndpointTable organizationId={facility.organizationId ?? ""} facility={facility} facilityId={facility.id} onDataChange={handleEndpointDataChange} />
            <LuxcomBiuSettings organizationId={facility.organizationId ?? ""} facilityId={facility.id} refreshKey={triggerRefreshKey} endpointRefreshKey={endpointRefreshKey} onDataChange={handleTriggerDataChange} />
            <EventTriggerTable organizationId={facility.organizationId ?? ""} facilityId={facility.id} refreshKey={triggerRefreshKey} onDataChange={handleTriggerDataChange} />
        </>
    );
};
